import { useMemo } from 'react';
import { uploadImage, createDeviceImage, deleteDeviceImage, fetchDeviceImages } from 'src/api/api2';
import { createCatchImage, deleteCatchImage, fetchCatchImages } from 'src/api/api2';
import { createGroupMap, updateGroupMap, deleteGroupMap, fetchGroupMaps, fetchGroupMap } from 'src/api/api2';

import { useSWR } from 'src/utils/swr';
import { useAction } from 'src/hooks/action';
import { useSystemStore } from 'src/stores';

export function useCreateDeviceImage(mutate) {
  const { token } = useSystemStore();
  return useAction(async (data) => {
    const { name, file_name } = await uploadImage(data.file, token);
    return await createDeviceImage({ id: data.id, name, file_name }, token);
  }, mutate);
}

export function useDeleteDeviceImage(mutate) {
  const { token } = useSystemStore();
  return useAction(data => deleteDeviceImage(data, token), mutate);
}

export function useFetchDeviceImages({ id }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => [], []);

  return useSWR(['/device-images', id], () => fetchDeviceImages({ id }, token), { defaultValue });
}

export function useCreateCatchImage(mutate) {
  const { token } = useSystemStore();
  return useAction(async (data) => {
    const { name, file_name } = await uploadImage(data.file, token);
    return await createCatchImage({ id: data.id, name, file_name }, token);
  }, mutate);
}

export function useDeleteCatchImage(mutate) {
  const { token } = useSystemStore();
  return useAction(data => deleteCatchImage(data, token), mutate);
}

export function useFetchCatchImages({ id }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => [], []);

  return useSWR(['/catch-images', id], () => id === undefined ? defaultValue : fetchCatchImages({ id }, token), { defaultValue });
}

export function useCreateOrUpdateGroupMap(mutate) {
  const { token } = useSystemStore();
  return useAction(async (data) => {
    const params = { ...data };
    if (data.file) {
      const { name, file_name } = await uploadImage(data.file, token);
      params.file_name = file_name;
      if (!params.name) {
        params.name = name;
      }
    }
    return data.map_id !== undefined ? await updateGroupMap(params, token) : await createGroupMap(params, token);
  }, mutate);
}

export function useDeleteGroupMap(mutate) {
  const { token } = useSystemStore();
  return useAction(data => deleteGroupMap(data, token), mutate);
}

export function useFetchGroupMaps({ id }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => [], []);

  return useSWR(['/group-maps', id], () => fetchGroupMaps({ id }, token), { defaultValue });
} 

export function useFetchGroupMap({ id, map_id }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => ({}), []);

  const fetcher = async () => {
    const item = await fetchGroupMap({ id, map_id }, token);
    return item ?? {};
  }
  return useSWR(map_id !== undefined ? ['/group-map', id, map_id] : null, fetcher, { defaultValue });
}